import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Pagination_Holder from "../../../../../../../common/common_components/pagination_holder/Pagination_Holder";
import { useDispatch, useSelector } from "react-redux";
import { GetAll, Delete } from "../../../../../../../../src/features/admin/quality_management/resource_requirement/training_details/Slice";
import { GETAuthLogin } from "../../../../../../../features/auth/Slice";
import { formatDate } from "../../../../../../../utils/common";
import { faPen, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import Raised_Training_Edit_Offcanvas from "../Raised_Training_Edit_Offcanvas/Raised_Training_Edit_Offcanvas";
import Delete_offcanvas from "../../../../../../../common/common_offcanvas/delete_offcanvas/Delete_offcanvas";
import { FixIDS } from "../../../../../../../utils/fixIDS";

function Raised_Training_table() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const personaldetails = useSelector((state) => state.training_details);

  const authdetails = useSelector((state) => state.auth);

  const [showEdit, setEdit] = useState(false);
  const [showEditId, setEditId] = useState(null);

  const [showDelete, setDelete] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);

  const fetchCustomers = async (page = 1) => {
    await dispatch(
      GetAll({
        page,
        per_page: personaldetails.per_page,
      }),
    );
  };

  useEffect(() => {
    fetchCustomers(currentPage);
    dispatch(GETAuthLogin());
  }, [dispatch, currentPage]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  /* ================= DELETE ================= */
  const handleDelete = async () => {
    if (!selectedDeleteId) return;

    try {
      await dispatch(Delete(selectedDeleteId)).unwrap(); // call redux thunk
      fetchCustomers(currentPage); // refresh the table
      // setDelete(false); // close offcanvas
      setSelectedDeleteId(null); // reset
    } catch (err) {
      console.error("Delete failed", err);
      alert("Delete failed");
    }
  };

  const permissions = useSelector((state) => state.auth.permissions);

  const haveReadPermission = permissions?.includes(
    FixIDS.training_details.List,
  );
  const haveEditPermission = permissions?.includes(
    FixIDS.training_details.Edit,
  );
  const haveDeletePermission = permissions?.includes(
    FixIDS.training_details.Delete,
  );
  const haveViewPermission = permissions?.includes(
    FixIDS.training_details.View,
  );

  return (
    <>
      <section className="Imperiality_table">
        <div className="common_table_container theme_bg">
          <div className="table-responsive">
            <table className="common_table table table-striped customer_table">
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Date</th>
                  <th>Name</th>
                  <th>Contact No.</th>
                  <th>Email</th>
                  <th>Type of Training</th>
                  <th>Training Field</th>
                  <th>Duration</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {personaldetails?.data?.map((row, index) => (
                  <tr key={index}>
                    <td>
                      {(personaldetails?.current_page - 1) *
                        personaldetails?.per_page +
                        index +
                        1}
                    </td>
                    <td>{formatDate(row?.createdAt)}</td>
                    <td>{row?.User?.name}</td>
                    <td>{row.User?.contact_no}</td>
                    <td>{row.User?.email}</td>
                    <td>{row.Type_Of_Training?.name}</td>
                    <td>{row.Training_Field?.name}</td>
                    <td>{row.duration}</td>

                    {/* Action */}
                    <td>
                      <div className="action_icons">
                        
                        {haveEditPermission && (
                          <FontAwesomeIcon
                            icon={faPen}
                            onClick={() => {
                              setEdit(true);
                              setEditId(row.id);
                            }}
                          />
                        )}
                        {haveDeletePermission && (
                          <FontAwesomeIcon
                            icon={faTrashCan}
                            onClick={() => {
                              setSelectedDeleteId(row.id); // store ID
                              setDelete(true); // open offcanvas
                            }}
                          />
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="comon_page_footer">
          <div className="show_entry_div">
            <p className="show_text">
              Showing {personaldetails?.data.length} of{" "}
              {personaldetails?.total || 0} Entries
            </p>
          </div>

          <div className="pagination_div">
            <Pagination_Holder
              onPageChange={currentPage}
              totalPages={personaldetails?.total_pages}
              handlePageChange={handlePageChange}
            />
          </div>
        </div>
      </section>

      {/* Edit */}
      {haveEditPermission && (
        <Raised_Training_Edit_Offcanvas
          show={showEdit}
          handleClose={() => setEdit(false)}
          id={showEditId}
        />
      )}


      { haveDeletePermission && <Delete_offcanvas
        show={showDelete}
        handleClose={() => setDelete(false)}
        handleDelete={handleDelete}
        offcanvasHeading="Training Details"
        massageText={""}
      />}
      
    </>
  );
}

export default Raised_Training_table;
